<template>
  <AppSelect
    :value="value"
    :options="cities"
    :loading="loading"
    :remote-search="suggestCities"
    remote-search-text="Введите название города"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
  ></AppSelect>
</template>

<script>
import debounce from "debounce-async";
import siteService from "@/services/site";

const suggestCitiesWithDebounce = debounce(siteService.suggestCities, 300, {
  leading: true
});

export default {
  name: "CitySelector",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {}
  },
  data: () => ({
    loading: false,
    cities: []
  }),
  methods: {
    async suggestCities(query = "") {
      this.loading = true;
      this.cities = await suggestCitiesWithDebounce(query);
      this.loading = false;
    }
  }
};
</script>

<style></style>
